import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';

import {
  ContestDukeRectorTwoDragonsLink,
  ContestEverythingWillBeFineLink,
  ContestStorySapphireLink, ContestZhenitNelzyaPomilovatLink,
} from '~/atomic/atom/links/staticLinks';
import { PageTitleStyle } from '~/atomic/Typography';
import { isMobileSizeSelector, windowSizeSelector } from '~/feature/media/windowSize.selector';
import { lessThan } from '~/lib/mediaQuery';
import { useAppSelector } from '~/store';

export const Contests = () => {
  const { size } = useAppSelector(windowSizeSelector);
  const isMobileSize = useAppSelector(isMobileSizeSelector);
  const width = size.width > 0 ? size.width : 1920;

  const imageWidth = width >= 1200 ? 1200 : size.width - 24;
  const imageHeight = Math.round(imageWidth * (isMobileSize ? 0.312 : 0.155));

  return (
    <SCContests>
      <SCTitle>
        Список всех конкурсов
      </SCTitle>
      <ContestZhenitNelzyaPomilovatLink>
        <a>
          <SCFeedBanner
            width={imageWidth}
            height={imageHeight}
            src="https://storage.bookriver.ru/storage/banners/zhenitnelzyapomilovath.jpg"
            alt="баннер"
          />
        </a>
      </ContestZhenitNelzyaPomilovatLink>
      <ContestDukeRectorTwoDragonsLink>
        <a>
          <SCFeedBanner
            width={imageWidth}
            height={imageHeight}
            src={isMobileSize
              ? '/image/contest/duke-rector-two-dragons/feed-mobile-banner.jpg'
              : '/image/contest/duke-rector-two-dragons/feed-banner.jpg'}
            alt="баннер"
          />
        </a>
      </ContestDukeRectorTwoDragonsLink>
      <ContestStorySapphireLink>
        <a>
          <SCFeedBanner
            width={imageWidth}
            height={imageHeight}
            src={isMobileSize
              ? '/image/contest/story-sapphire/feed-mobile-banner.jpg'
              : '/image/contest/story-sapphire/feed-banner.jpg'}
            alt="баннер"
          />
        </a>
      </ContestStorySapphireLink>
      <ContestEverythingWillBeFineLink>
        <a>
          <SCFeedBanner
            width={imageWidth}
            height={imageHeight}
            src={isMobileSize
              ? '/image/contest/everything-will-be-fine/feed-mobile-banner.jpg'
              : '/image/contest/everything-will-be-fine/feed-banner.jpg'}
            alt="баннер"
          />
        </a>
      </ContestEverythingWillBeFineLink>
    </SCContests>
  );
};

const SCContests = styled.div`
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  > *:not(:last-child) {
    display: flex !important;
    margin-bottom: 24px !important;
  }
`;

const SCTitle = styled.h1`
  ${PageTitleStyle};
  margin-bottom: 32px;
`;

const SCFeedBanner = styled(Image)`
  width: 100%;
  background-color: hsla(0,0%,74.5%,.2);
  max-height: calc((100vw - 24px) * 0.155);
  
  ${lessThan('sm')} {
    max-height: calc((100vw - 24px) * 0.312);
  }
`;
